<div class="container pt-5 px-lg-0">
	<div class="my-5">
		<div class="text-center mb-2">
			<h1 class="titolo-bertazzoni">TRANSCODING CUSTOMER CODES</h1>
			<button type="button" class="btn btn-bertazzoni black rounded-0 mt-3" (click)="apriModaleDettaglio(content)">NEW RECORD</button>
		</div>
		<div class="row">
			<div class="col-12">
				<!--LASCIARE ORDINAMENTO SOLO SU COLONNA CLIENTE AS400, LE SELECT DELLE ALTRE DUE COLONNE PARTONO DISABILITATE E IL BTN SALVA NASCOSTO. SI ATTIVA TUTTO AL CLICK SULLA MODIFICA-->
				<table datatable [dtTrigger]="dtTrigger" class="row-border hover">
					<thead>
						<tr>
							<th>Customer</th>
							<th>Customer commercial code</th>
							<th>Bertazzoni commercial code</th>
							<th></th>
						</tr>
					</thead>
					<tbody *ngIf="transcodifiche.length > 0">
						<tr *ngFor="let transcodifica of transcodifiche">
							<td>{{transcodifica.codiceCliente}}</td>
							<td>{{transcodifica.codiceCommercialeCliente}}</td>
							<td>{{transcodifica.codiceCommercialeBertazzoni}}</td>
							<th>
								<img src="assets/img/pencil.svg" class="action-icon" (click)="apriModaleDettaglio(content, transcodifica)" />
							</th>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>

<ng-template #content let-modal>
	<form #form="ngForm">
		<div class="modal-header">
			<h5 class="modal-title" *ngIf="transcodificaSelected.id">Edit transcoding</h5>
			<h5 class="modal-title" *ngIf="!transcodificaSelected.id">Enter transcoding</h5>
			<button type="button" class="close" aria-label="Close" (click)="modal.close()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<div class="col-12">
				<label class="font-semibold">Customer code</label>
				<input
					type="text"
					class="form-control mb-2 rounded-0 form-bertazzoni white"
					placeholder="Customer Code"
					name="codiceCliente"
					[(ngModel)]="transcodificaSelected.codiceCliente"
					required />
			</div>
			<div class="col-12 mt-2">
				<label class="font-semibold">Customer commercial code</label>
				<input
					type="text"
					class="form-control mb-2 rounded-0 form-bertazzoni white"
					placeholder="Customer commercial code"
					name="codiceCommercialeCliente"
					[(ngModel)]="transcodificaSelected.codiceCommercialeCliente"
					required />
			</div>
			<div class="col-12 mt-2">
				<label class="font-semibold">Bertazzoni commercial code</label>
				<input
					type="text"
					class="form-control mb-2 rounded-0 form-bertazzoni white"
					placeholder="Bertazzoni commercial code"
					name="codiceCommercialeBertazzoni"
					[(ngModel)]="transcodificaSelected.codiceCommercialeBertazzoni"
					required />
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-bertazzoni white rounded-0 py-2" (click)="modal.close()">Close</button>
			<button type="button" class="btn btn-bertazzoni black rounded-0 py-2 ml-2" (click)="salva(modal)" [disabled]="form.invalid">
				Save
			</button>
		</div>
	</form>
</ng-template>
